<template>
  <el-dialog
    title="学员信息修改"
    :visible="true"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(false)
      }
    "
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="证件号码" prop="idCard">
        <el-input v-model="form.idCard"></el-input>
      </el-form-item>
      <el-form-item label="账号">
        <el-input disabled v-model="form.account"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="出生日期">
        <el-date-picker
          v-model="form.birthday"
          type="date"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="性别">
        <el-select v-model="form.sex" placeholder="请选择">
          <el-option label="男" :value="1"></el-option
          ><el-option label="女" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="民族">
        <el-input v-model="form.nation"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="职级">
        <el-input v-model="form.rank"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="twoUnit">
        <el-input v-model="form.twoUnit"></el-input>
      </el-form-item>
      <el-form-item label="部门">
        <el-input v-model="form.dept"></el-input>
      </el-form-item>
      <el-form-item label="职务">
        <el-input v-model="form.position"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="form.remarks"
          type="textarea"
          maxlength="200"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button class="search-but1" size="small" @click="handleClose(false)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as API from '../../api/students/index'
export default {
  name: 'StudentsWrite',
  props: ['handleClose', 'defaultData'],
  data() {
    return {
      form: {
        ...this.defaultData
      },
      rules: {
        idCard: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        name: [{ required: true, message: '必填项不可为空', trigger: 'blur' }],
        phone: [{ required: true, message: '必填项不可为空', trigger: 'blur' }],
        twoUnit: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate(async (validate) => {
        if (validate) {
          const data = { ...this.form }
          const res = await API.updateStudent(data)
          const { code } = res
          if (code === 0) {
            this.$message.success('保存成功')
            this.handleClose(true)
          }
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.write-footer {
  text-align: right;
}
</style>